


























































import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import AccountIcon from '@tt4b/ttam-assets/src/svgs/creative/business_account_icon.svg';
import RecommendIcon from '@tt4b/ttam-assets/src/svgs/creative/vi-icon-recommend.svg';
const name = 'ttam-tiktok-account-popover';

export default defineComponent({
  name,
  components: {
    RecommendIcon,
    AccountIcon,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object as PropType<{ name: string; avatar: string }>,
      default: () => null,
    },
    ctaLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { info } = toRefs(props);

    const avatar = computed(() => info.value?.avatar);
    const userName = computed(() => info.value?.name);

    const onVisible = (val: boolean) => {
      emit('update:visible', val);
    };

    const onLinkClick = () => {
      emit('link');
    };

    const onUnLink = () => {
      emit('unlink');
    };

    return {
      name,
      avatar,
      userName,
      onUnLink,
      onVisible,
      onLinkClick,
    };
  },
});
